import { SHA256 } from '../helpers/utils';
import store from '../stores/store';
let aesjs = require('aes-js');
/**
 * Decrypt document and return it in bytes
 * @param arrayBuffer
 * @param key_bytes
 * @param IV_bytes
 * @returns {*}
 */
export function decryptDocument(arrayBuffer, key_bytes, IV_bytes) {
    // create array of Unsigned Integer8 bytes
    let uint8arr = new Uint8Array(arrayBuffer);
    // console.log('encrypted uint8arr', uint8arr);

    // aesjs method start

    // console.log('IV_bytes', IV_bytes);
    // create settings for decryption
    let aesCbc = new aesjs.ModeOfOperation.cbc(key_bytes, IV_bytes);

    // decrypt array
    return aesjs.padding.pkcs7.strip(aesCbc.decrypt(uint8arr));
    // let decryptedBytes = aesCbc.decrypt(uint8arr);
    // console.log('decryptedBytes', decryptedBytes);
    // return decryptedBytes;

    // aesjs method finish
}

export function encryptNotes(source, key_bytes, IV_bytes) {
    // console.group("encryptNotes", source, key_bytes, IV_bytes);

    let textBytes = aesjs.utils.utf8.toBytes(source);
    // console.log('textBytes', textBytes);

    let aesCbc = new aesjs.ModeOfOperation.cbc(key_bytes, IV_bytes);
    let encryptedBytes = aesCbc.encrypt(aesjs.padding.pkcs7.pad(textBytes));
    return aesjs.utils.hex.fromBytes(encryptedBytes);

    // console.log('encryptedBytes', encryptedBytes);
    // console.log("encryptedHex", encryptedHex);
    // console.groupEnd();
    // return encryptedHex;
}

export function decryptNotes(source, key_bytes, IV_bytes) {
    // console.group("decryptNotes", {source, key_bytes, IV_bytes});

    let encryptedBytes = aesjs.utils.hex.toBytes(source);
    // console.log('encryptedBytes', encryptedBytes);

    let aesCbc = new aesjs.ModeOfOperation.cbc(key_bytes, IV_bytes);
    let decryptedBytes = aesjs.padding.pkcs7.strip(aesCbc.decrypt(encryptedBytes));

    return aesjs.utils.utf8.fromBytes(decryptedBytes);

    // console.log('decryptedBytes', decryptedBytes);
    // console.log("decryptedString", decryptedString);
    // console.groupEnd();
    // return decryptedString;
}

/**
 * create Vector key in bytes
 * @param docId
 * @param instanceId
 * @param DocExtension
 * @returns {*}
 */
export function getIVInBytes(docId, instanceId, DocExtension) {
    let key = store.documents.documentToken;
    // create Int vector
    let int_vect = String(docId) + String(instanceId) + DocExtension + key;
    // console.log('decription getIVInBytes string', int_vect);
    // hash IV and convert to string and slice it to 16 chars

    let iv = SHA256(int_vect)
        .toString()
        .slice(0, 16);
    // console.log('decryption getIVInBytes hashed', iv)
    // convert to bytes
    return aesjs.utils.utf8.toBytes(iv);
    // return stringToBytes(iv);
}

/**
 * create Vector key in bytes
 * @param hashedPin
 * @returns {*}
 */
export function getIVInBytesForOfflineKey(hashedPin, userId) {
    // create Int vector
    let int_vect = hashedPin + hashedPin + userId;

    let iv = SHA256(int_vect)
        .toString()
        .slice(0, 16);

    // convert to bytes
    return aesjs.utils.utf8.toBytes(iv);
}

/**
 * create UDK
 * @param offlineKey
 * @param hashedPin
 * @returns {*}
 */
export function decryptOfflineKey(offlineKey, hashedPin, IV_bytes) {
    let encryptedBytes = aesjs.utils.hex.toBytes(offlineKey);
    hashedPin = hashedPin.substring(0, 32);
    let key = aesjs.utils.utf8.toBytes(hashedPin);
    let aesCbc = new aesjs.ModeOfOperation.cbc(key, IV_bytes);
    let decryptedBytes = aesjs.padding.pkcs7.strip(aesCbc.decrypt(encryptedBytes));
    return aesjs.utils.utf8.fromBytes(decryptedBytes);
}

/**
 * create key in bytes
 * @returns {*}
 */
export function getKeyInBytes() {
    let key = store.documents.documentToken;
    // console.log('decription getKeyInBytes', key);

    if (!key) {
        // console.log('no key - need to get one');
        store.documents.tokenErrorON();
        throw new Error('No document token');
    }

    // create hash Key and slice it to 32 chars
    let hashedKey = SHA256(key)
        .toString()
        .slice(0, 32);
    // convert to bytes
    return aesjs.utils.utf8.toBytes(hashedKey);
}



// WEBPACK FOOTER //
// ./src/helpers/decryption.js